import { useState } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
import Button, { ButtonProps } from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Modal from './Modal'

export type DialogConfirmProps = BoxProps & {
  confirm?: boolean
  title?: React.ReactNode
  action?: string
  disabled?: boolean
  fullWidth?: boolean
  color?: ButtonProps['color']
  dialogChildren?: React.ReactNode
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void
  onDeny?: () => void
}

const DialogConfirm: React.FC<DialogConfirmProps> = ({
  confirm = true,
  title = 'Are you sure?',
  action = 'Ok',
  onConfirm,
  onDeny,
  color = 'primary',
  disabled,
  children,
  dialogChildren,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (disabled) return
    props.onClick?.(e)
    if (confirm) setOpen(true)
  }

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    onConfirm(e)
    setOpen(false)
  }

  const handleDeny = () => {
    onDeny?.()
    setOpen(false)
  }

  return (
    <>
      <Box {...props} onClick={handleClick} component="span">
        {children}
      </Box>
      <Modal open={open} onClose={handleDeny} color={color + '.main'}>
        <DialogTitle variant="subtitle1" color={color}>
          {title}
        </DialogTitle>
        <DialogContent>{dialogChildren}</DialogContent>
        <DialogActions>
          <Button variant="text" sx={{ color: 'GrayText' }} onClick={handleDeny}>
            Cancel
          </Button>
          <Button autoFocus variant="contained" color={color} disabled={disabled} onClick={handleConfirm}>
            {action}
          </Button>
        </DialogActions>
      </Modal>
    </>
  )
}

export default DialogConfirm
